import React from 'react';

// eslint-disable-next-line react/prop-types
const FlagshipSharedBottom = ({ reservationLink, shopName }) => (
  <div>
    <div className="flgshp-footer u-mb-10 u-mt-5">
      <div className="column u-text-small u-co-grey u-hide-breaks-on-mobile">
        {/* eslint-disable quotes */}
        Squire Technologies is a company{` `}
        <br />
        dedicated to making style and{` `}
        <br />
        grooming simple for everyone.
        {/* eslint-enable quotes */}
      </div>
      <div className="column u-text-small u-co-grey">
        <span className="u-text-small u-co-grey">
          If you need to modify or cancel this appointment,&nbsp;
          <a className="u-co-grey u-td-underline" href={reservationLink} target="_blank" rel="noopener noreferrer">
            view reservation
          </a>
          .
        </span>
      </div>
    </div>

    <div className="c-divider" />

    <div className="c-footer-info">
      <div className="u-text-tiny u-co-grey--light u-hide-breaks-on-mobile u-pr-5">
        You&apos;re receiving this email because you use Squire to&nbsp;
        <br />
        manage your appointments for {shopName}.
      </div>
      <a
        href="https://www.instagram.com/getsquire"
        className="u-flex u-align-center u-text-small u-co-grey"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img width="20px" src="https://assets.getsquire.com/images/instagram@4x.png" alt="" />
        &nbsp;&nbsp;
        <span className="u-mr-2">Instagram</span>
      </a>
    </div>
  </div>
);

export default FlagshipSharedBottom;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/FlagshipSharedBottom.jsx